import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Common
import koCommon from './locales/ko/common.json';
import enCommon from './locales/en/common.json';

export enum I18nNS {
  COMMON = 'common',
  KEYWORDS = 'keywords',
  CURRICULUMS = 'curriculums',
  GRADES = 'grades',
  SUBJECTS = 'subjects',
  TUTORIALTYPES = 'tutorialTypes',
  LEVELS = 'levels',
  BOARDFAQTYPES = 'boardFaqTypes',
  STORES = 'storeCategory',
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    defaultNS: I18nNS.COMMON,
    ns: [I18nNS.COMMON],
    resources: {
      en: {
        common: enCommon,
      },
      ko: {
        common: koCommon,
      },
    },
    detection: {
      order: ['htmlTag', 'cookie'],
      lookupCookie: 'lang',
      lookupQuerystring: 'lang',
      caches: ['cookie'],
    },
    react: {
      useSuspense: true,
    },

    keySeparator: false,
  });

export default i18n;
